module.exports = __webpack_public_path__ + "static/media/image-3-4.cd6b92e2.png";